module.exports = "/content/a1b41957aaab173ac1cd558827d28271.png";